import React from "react";
import styled from "styled-components";

interface IProps {
  children: React.ReactNode;
}

const StyledDialogHeading = styled.div`
  color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.fonts.base};
  font-size: 18px;
  line-height: 26px;
  font-weight: bold;
`;

const DialogHeading: React.FC<IProps> = ({ children }) => {
  return <StyledDialogHeading>{children}</StyledDialogHeading>;
};

export default DialogHeading;
